<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">现货委托管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>现货资产</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <div class="select">
          <el-input
            v-model="userId"
            clearable
            size="mini"
            class="item"
            placeholder="用户UID"
          />
          <el-select
            v-model="coin"
            clearable
            filterable
            size="mini"
            class="item"
            placeholder="请选择币种"
          >
            <el-option label="全部币种" value="" />
            <el-option
              v-for="item in coinOptions"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
          <el-button size="mini" type="primary" @click="search">查询</el-button>
        </div>
        <div class="total">资产汇总(USDT): {{ totalAmount }}</div>
      </div>

      <el-table :data="list" size="small" border height="calc(100vh - 320px)">
        <el-table-column label="用户UID" prop="userId" min-width="120" />
        <el-table-column label="币种" prop="coin" min-width="100" />
        <el-table-column label="可用数量" prop="amount" min-width="160" />
        <el-table-column label="冻结数量" prop="coinFroze" min-width="160" />
        <el-table-column label="币价(USDT)" prop="price" min-width="140" />
        <el-table-column label="可用折算(USDT)" prop="amountToU" min-width="180" />
        <el-table-column label="冻结折算(USDT)" prop="coinFrozeToU" min-width="180" />
      </el-table>

      <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="pageChanged"
      />
    </el-card>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import api from "./api";

const PAGINATION = {
  page: 1,
  size: 25,
};

export default {
  name: "OrderLimitSpotAssets",
  components: {
    Pagination,
  },
  data() {
    return {
      userId: "",
      coin: "",
      coinOptions: [],
      list: [],
      totalCount: 0,
      totalAmount: "--",
      pagination: { ...PAGINATION },
    };
  },
  methods: {
    loadList(extra = {}) {
      const params = {
        page: this.pagination.page,
        size: this.pagination.size,
        userId: this.userId ? Number(this.userId) : null,
        coin: this.coin ? this.coin.trim() : null,
        ...extra,
      };
      api.getSpotAssetsList(params).then((res) => {
        if (res.code == 0) {
          this.list = (res.data && res.data.list) || [];
          this.totalCount = (res.data && res.data.totalCount) || 0;
        }
      });
      this.loadTotal();
    },
    loadTotal() {
      api
        .getSpotAssetsTotal({
          userId: this.userId ? Number(this.userId) : null,
          coin: this.coin ? this.coin.trim() : null,
        })
        .then((res) => {
          if (res.code == 0) {
            this.totalAmount = res.data || "0";
            return;
          }
          this.totalAmount = "--";
        })
        .catch(() => {
          this.totalAmount = "--";
        });
    },
    loadCoinOptions() {
      api.getSpotCoinList().then((res) => {
        if (res.code == 0) {
          const raw = res.data || res.result || [];
          this.coinOptions = Array.isArray(raw)
            ? raw
                .map((v) => (v || "").toString().trim().toUpperCase())
                .filter(Boolean)
            : [];
        }
      });
    },
    search() {
      this.pagination = { ...PAGINATION };
      this.loadList();
    },
    pageChanged(pagination) {
      this.pagination = pagination;
      this.loadList();
    },
  },
  mounted() {
    this.loadCoinOptions();
    this.loadList();
  },
};
</script>

<style lang="less" scoped>
.page-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.select {
  display: flex;
  align-items: center;
}
.item {
  width: 180px;
  margin-right: 10px;
}
.total {
  font-size: 13px;
  color: #606266;
}
</style>
